import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { ArrayMaxSize, ArrayNotEmpty, IsArray, IsDefined, IsNotEmpty, IsNumber, IsOptional, IsString, IsUUID, Length, Min, ValidateIf, ValidateNested, } from 'class-validator';
import { IsSupportedText, SupportedLineMode } from '../../shared/validator';
import { HearingSegment } from '../../type/court';
import { MAX_APPEARANCES } from '../../type/order';
import { Appearance } from '../../type/transcript';
import { LineItemRequest } from './LineItemRequest';
export const JUDGES_MIN_LENGTH = 1;
export const JUDGES_MAX_LENGTH = 100;
export const LANGUAGES_MIN_LENGTH = 1;
export const LANGUAGES_MAX_LENGTH = 100;
/**
 * A request for a transcript of part of the court record
 */
export class TranscriptLineItemRequest extends LineItemRequest {
    constructor(caseNumber, caseTitle, locationId, hearingSegments, hearingPortions, turnaroundId, departmentId, caseType, paperCopies, judges, appearances, languages, instructions, distributionList) {
        super(locationId, departmentId, distributionList);
        this.caseNumber = caseNumber;
        this.caseTitle = caseTitle;
        this.hearingSegments = hearingSegments;
        this.hearingPortions = hearingPortions;
        this.turnaroundId = turnaroundId;
        this.caseType = caseType;
        this.paperCopies = paperCopies;
        this.judges = judges;
        this.appearances = appearances;
        this.languages = languages;
        this.instructions = instructions;
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], TranscriptLineItemRequest.prototype, "caseNumber", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], TranscriptLineItemRequest.prototype, "caseTitle", void 0);
__decorate([
    Type(() => HearingSegment),
    ValidateNested(),
    __metadata("design:type", Array)
], TranscriptLineItemRequest.prototype, "hearingSegments", void 0);
__decorate([
    IsDefined(),
    IsArray(),
    ArrayNotEmpty(),
    __metadata("design:type", Array)
], TranscriptLineItemRequest.prototype, "hearingPortions", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], TranscriptLineItemRequest.prototype, "turnaroundId", void 0);
__decorate([
    IsOptional(),
    IsNotEmpty(),
    __metadata("design:type", Object)
], TranscriptLineItemRequest.prototype, "caseType", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    Min(0),
    __metadata("design:type", Object)
], TranscriptLineItemRequest.prototype, "paperCopies", void 0);
__decorate([
    ValidateIf(o => !!o.judges),
    IsSupportedText(SupportedLineMode.SINGLE),
    IsString(),
    Length(JUDGES_MIN_LENGTH, JUDGES_MAX_LENGTH),
    __metadata("design:type", Object)
], TranscriptLineItemRequest.prototype, "judges", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ArrayMaxSize(MAX_APPEARANCES),
    Type(() => Appearance),
    ValidateNested(),
    __metadata("design:type", Object)
], TranscriptLineItemRequest.prototype, "appearances", void 0);
__decorate([
    ValidateIf(o => !!o.languages),
    IsSupportedText(SupportedLineMode.SINGLE),
    IsString(),
    Length(LANGUAGES_MIN_LENGTH, LANGUAGES_MAX_LENGTH),
    __metadata("design:type", Object)
], TranscriptLineItemRequest.prototype, "languages", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], TranscriptLineItemRequest.prototype, "instructions", void 0);
export function isTranscriptLineItemRequest(lineItemRequest) {
    return lineItemRequest instanceof TranscriptLineItemRequest;
}
